import { BaseApi } from '@codes/base-api';

import type { SecretCredentialBody, SecretCredentialView } from '../types';

/**
 * Secret Credentials API client
 * Endpoints:
 * - GET /access-keys - List all credentials
 * - GET /access-keys/${id}/detail - Get credential detail
 * - POST /access-keys/0 - Create new credential
 * - PUT /access-keys/${id} - Update credential
 * - DELETE /access-keys/${id} - Delete/revoke credential
 */
export const accessKeysApi = new BaseApi<SecretCredentialView, SecretCredentialBody>('access-keys', {
    endpoint: import.meta.env.VITE_BACKEND_ENDPOINT.toLowerCase(),
});
